import {atom} from "recoil";
import {LOCALE_STORAGE_KEY} from "../../core/variables";

const getDefaultLocale = () => {
    const localStorageLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY);

    //TODO add logic to set locale if query param exist (for switch to console)

    if (localStorageLocale) {
        return localStorageLocale;
    } else {
        return Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Seoul" ? "ko" : "en";
    }
}

const localeState = atom<"en"|"ko"|string>({
    key: "locale",
    default: getDefaultLocale(),
    effects: [
        ({ onSet }) => {
            onSet(newLocale => {
                window.localStorage.setItem(LOCALE_STORAGE_KEY, newLocale);
            })
        }
    ]
});

export default localeState;
